import { ComponentProps, forwardRef } from "react"

import { Popover, styled } from "@mui/material"

const StyledPopRow = styled("button")(({ theme }) => ({
  display: "block",
  width: "190px",
  fontWeight: 500,
  padding: "12px 16px",
  fontSize: "14px",
  fontFamily: "inherit",
  cursor: "pointer",
  color: theme.palette.mockup.neutral10,
  textAlign: "left",
  background: "none",
  border: "none",
  margin: 0,
  "&:hover": {
    backgroundColor: theme.palette.mockup.primary95,
  },
}))

export const PopRow = forwardRef<
  HTMLButtonElement,
  ComponentProps<typeof StyledPopRow>
>(function PopRow({ type = "button", ...props }, ref) {
  return <StyledPopRow ref={ref} type={type} {...props} />
})

export const PopOverStyle = styled(Popover)(({ theme }) => ({
  "& .MuiPaper-root.MuiPopover-paper": {
    borderRadius: "16px",
    border: `1px solid ${theme.palette.mockup.neutral40}`,
    boxShadow: "none",
  },
}))
